module.exports = __webpack_public_path__ + "static/bg5-4aa786af0d56ec6caa37f05c5a31d966.png";